import { Icon } from '@design/components/icon/Icon';
import * as Radix from '@radix-ui/react-dropdown-menu';
import clsx from 'clsx';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { ConditionOptions } from '../utils/getConditionOptions';
import styles from './RunScenario.module.scss';

interface ConditionsDropdownProps {
  name: string;
  customCondition?: ConditionOptions;
  handleSetCustomCondition: (condition: ConditionOptions) => void;
  conditionOptions: ConditionOptions[];
}

export const ConditionsDropdown = ({
  name,
  customCondition,
  handleSetCustomCondition,
  conditionOptions,
}: ConditionsDropdownProps) => {
  const { t } = useTranslation(['calendar']);

  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className={styles.filterWrapper}>
      <label className={styles.filterLabel}>
        {t('calendar:scenario.whenLabel')} {name}
      </label>
      <Radix.Root open={isOpen} onOpenChange={setIsOpen}>
        <Radix.Trigger
          className={clsx(styles.conditionTrigger, {
            [styles.active]: !!customCondition,
          })}
          onClick={() => setIsOpen(true)}
        >
          <span className={styles.triggerLabel} data-testid="condition-dropdown-label">
            {customCondition?.value ?? t('calendar:scenario.condition')}
          </span>
          <Icon className={styles.triggerArrow} iconName="ChevronLightDown" size={14} />
        </Radix.Trigger>
        <Radix.Portal>
          <Radix.Content
            className={styles.dropdownMenuContent}
            align="start"
            sideOffset={5}
            collisionPadding={5}
            onInteractOutside={() => setIsOpen(false)}
          >
            <span className={styles.conditionTitle}>{name}</span>
            {conditionOptions.map(({ value, config }) => {
              return (
                <Radix.Item
                  key={value}
                  className={clsx(styles.item, {
                    [styles.checked]: customCondition?.value === value,
                  })}
                  onSelect={e => {
                    e.preventDefault();
                    handleSetCustomCondition({ value, config });
                  }}
                >
                  <span className={styles.menuItemLeftIndicator} />
                  <div className={styles.itemText}>{value}</div>
                </Radix.Item>
              );
            })}
          </Radix.Content>
        </Radix.Portal>
      </Radix.Root>
    </div>
  );
};
